import { ChatContextType } from '@/types/chat';

export interface SuggestedChatPrompt {
  contextType: ChatContextType;
  prompt: string;
}

export const SUGGESTED_CHAT_PROMPTS_BY_CONTEXT: Record<
  ChatContextType,
  SuggestedChatPrompt[]
> = {
  [ChatContextType.Global]: [
    {
      contextType: ChatContextType.Global,
      prompt: 'Tell me about trends over the past week',
    },
    {
      contextType: ChatContextType.Global,
      prompt: 'Find a customer or document',
    },
    {
      contextType: ChatContextType.Global,
      prompt: "I don't understand something",
    },
  ],
  [ChatContextType.Customer]: [
    {
      contextType: ChatContextType.Customer,
      prompt: 'Analyze this customer for fraud risk',
    },
    {
      contextType: ChatContextType.Customer,
      prompt: 'Find similar customers',
    },
    {
      contextType: ChatContextType.Customer,
      prompt: "I don't understand something",
    },
  ],
  [ChatContextType.Document]: [
    {
      contextType: ChatContextType.Document,
      prompt: 'Analyze this for fraud risk',
    },
    {
      contextType: ChatContextType.Document,
      prompt: 'Find similar documents',
    },
    {
      contextType: ChatContextType.Document,
      prompt: "I don't understand something",
    },
  ],
};
